import { useNavigate } from 'react-router-dom';
import { Calendar, User, ArrowRight, Clock, Tag } from 'lucide-react';
import '../../../assets/css/screens/customer/blogs/Blogs.css';
import Navbar from '../../../components/customer/home/Navbar/MyNavbar';
import Topbar from '../../../components/customer/home/topbar/Topbar';
import Footer from '../../../components/customer/home/footer/Myfooter';
import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import BlogCard from '../../../components/customer/home/blogcard/BlogCard';

const Blogs = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [blogs, setBlogs] = useState([]);
const [loading, setLoading] = useState(true);



const stripHTML = (html) => {
  if (!html) return "";

  // 1️⃣ Decode escaped HTML (&lt;h1&gt;)
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  const decoded = txt.value;

  // 2️⃣ Remove actual HTML tags
  const clean = decoded.replace(/<[^>]*>/g, "");

  // 3️⃣ Clean extra spaces
  return clean.replace(/\s+/g, " ").trim();
};
useEffect(() => {
  setLoading(true);

  axios.get(`${baseUrl}/user/viewblogs`)
    .then((response) => {
      if (response.data.success) {
        setBlogs(response.data.blogs);
      }
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      setLoading(false);
    });

}, [baseUrl]);

  return (
    <>
      <Topbar />
      <Navbar />

      {/* ✅ PREFIX WRAPPER ADDED */}
      <div className="blogs-page">

        <div className="blog-insights-section">
          <div className="blog-container">

            {/* Header */}
            <div className="blog-header">
              <div className="header-content">
                <span className="header-tag">Blog & Insights</span>
                <h2>Latest Articles & Tips</h2>
                <p>
                  Expert advice, industry insights, and helpful guides for homeowners across USA
                </p>
              </div>
            </div>

            {/* Blog Grid */}
          <div className="blog-grid">

  {loading ? (

    <div className="blogs-loading">
      <div className="blogs-spinner"></div>
      <p>Loading blogs...</p>
    </div>

  ) : (

    blogs.map((post) => (
      <BlogCard
        key={post.id}
        blog={{
          ...post,
          description: stripHTML(post.description)
        }}
        baseUrlForFile={baseUrlForFile}
        onReadMore={(blog) => navigate(`/blogs/${blog.url_slug}`)}
      />
    ))

  )}

</div>

          </div>
        </div>

      </div>

      <Footer />
    </>
  );
};

export default Blogs;